export default __webpack_public_path__ + "locales/bg/EmptyView.json?hash=2dc96118727be57624bed341a4f0df49";